import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  canStartQuiz,
  getQuizInstructions,
  startQuiz,
  submitAnswer,
  completeQuiz,
  cancelQuiz,
  getQuestionsAndAnswers,
  getQuizActions,
} from "./thunks";
import { QuizTriesState } from "./types";

export const name = "quizTries";

const initialState: QuizTriesState = {
  canStartQuiz: {
    data: false,
    status: "idle",
  },
  quizInstructions: {
    data: null,
    status: "idle",
  },
  startQuiz: {
    data: null,
    status: "idle",
  },
  submitAnswers: {
    status: "idle",
  },
  completeQuiz: {
    data: null,
    status: "idle",
  },
  cancelQuiz: {
    status: "idle",
  },
  questionsAndAnswers: {
    data: [],
    status: "idle",
  },
  quizActions: {
    data: [],
    status: "idle",
  },
};

export const canStartQuizAsync = createAsyncThunk(
  name + "/canStartQuiz",
  canStartQuiz
);

export const getQuizInstructionsAsync = createAsyncThunk(
  name + "/getQuizInstructions",
  getQuizInstructions
);

export const startQuizAsync = createAsyncThunk(name + "/startQuiz", startQuiz);

export const submitAnswerAsync = createAsyncThunk(
  name + "/submitAnswer",
  submitAnswer
);

export const completeQuizAsync = createAsyncThunk(
  name + "/completeQuiz",
  completeQuiz
);

export const cancelQuizAsync = createAsyncThunk(
  name + "/cancelQuiz",
  cancelQuiz
);

export const getQuestionsAndAnswersAsync = createAsyncThunk(
  name + "/getQuestionsAndAnswers",
  getQuestionsAndAnswers
);

export const getQuizActionsAsync = createAsyncThunk(
  name + "/getQuizActions",
  getQuizActions
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
    clearQuizActions: (state) => {
      state.quizActions = initialState.quizActions;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(canStartQuizAsync.pending, (state) => {
        state.canStartQuiz.status = "loading";
      })
      .addCase(canStartQuizAsync.fulfilled, (state, action) => {
        state.canStartQuiz = {
          data: action.payload,
          status: "idle",
        };
      })
      .addCase(canStartQuizAsync.rejected, (state) => {
        state.canStartQuiz.status = "failed";
      })
      .addCase(getQuizActionsAsync.pending, (state) => {
        state.quizActions.status = "loading";
      })
      .addCase(getQuizActionsAsync.fulfilled, (state, action) => {
        state.quizActions = {
          data: action.payload,
          status: "idle",
        };
      })
      .addCase(getQuizActionsAsync.rejected, (state) => {
        state.quizActions.status = "failed";
      })
      .addCase(getQuizInstructionsAsync.pending, (state) => {
        state.quizInstructions.status = "loading";
      })
      .addCase(getQuizInstructionsAsync.fulfilled, (state, action) => {
        state.quizInstructions = {
          data: action.payload,
          status: "idle",
        };
      })
      .addCase(getQuizInstructionsAsync.rejected, (state) => {
        state.quizInstructions.status = "failed";
      })
      .addCase(startQuizAsync.pending, (state) => {
        state.startQuiz.status = "loading";
      })
      .addCase(startQuizAsync.fulfilled, (state, action) => {
        state.startQuiz = {
          data: action.payload,
          status: "idle",
        };
      })
      .addCase(startQuizAsync.rejected, (state) => {
        state.startQuiz.status = "failed";
      })
      .addCase(submitAnswerAsync.pending, (state) => {
        state.submitAnswers.status = "loading";
      })
      .addCase(submitAnswerAsync.fulfilled, (state) => {
        state.submitAnswers.status = "idle";
      })
      .addCase(submitAnswerAsync.rejected, (state) => {
        state.submitAnswers.status = "failed";
      })
      .addCase(completeQuizAsync.pending, (state) => {
        state.completeQuiz.status = "loading";
      })
      .addCase(completeQuizAsync.fulfilled, (state, action) => {
        state.completeQuiz = {
          data: action.payload,
          status: "idle",
        };
      })
      .addCase(completeQuizAsync.rejected, (state) => {
        state.completeQuiz.status = "failed";
      })
      .addCase(cancelQuizAsync.pending, (state) => {
        state.cancelQuiz.status = "loading";
      })
      .addCase(cancelQuizAsync.fulfilled, (state) => {
        state.cancelQuiz.status = "idle";
      })
      .addCase(cancelQuizAsync.rejected, (state) => {
        state.cancelQuiz.status = "failed";
      })
      .addCase(getQuestionsAndAnswersAsync.pending, (state) => {
        state.questionsAndAnswers.status = "loading";
      })
      .addCase(getQuestionsAndAnswersAsync.fulfilled, (state, action) => {
        state.questionsAndAnswers = {
          data: action.payload,
          status: "idle",
        };
      })
      .addCase(getQuestionsAndAnswersAsync.rejected, (state) => {
        state.questionsAndAnswers.status = "failed";
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
